var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCE33",
    cx: 12,
    cy: 12,
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.200002, 7.200000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M9.53077917,0 L0.469294795,0 C0.052927607,0 -0.157170049,0.505195313 0.137849482,0.800214844 L3.74999792,4.41291016 L3.74999792,8.4375 C3.74999792,8.59044922 3.82462683,8.73378906 3.94993933,8.82152344 L5.51243933,9.91488281 C5.82070104,10.1306641 6.24999792,9.91197266 6.24999792,9.53085938 L6.24999792,4.41291016 L9.86224401,0.800214844 C10.1566581,0.50578125 9.94800573,0 9.53077917,0 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicability);
export default __webpack_public_path__ + "static/media/applicability.29ce1a252544c07a2d6cce3363807327.svg";
export { ForwardRef as ReactComponent };